import React from 'react';
import { Box, Grid } from '@mui/material';
import { LEAD_FIELDS } from './LeadFieldMappings';

const RequiredFields = () => {
  const fields = Object.entries(LEAD_FIELDS).map(([key, config]) => ({
    label: config.label + (config.required ? ' (required)' : ''),
    required: config.required
  }));

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {fields.map((field, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Box
            sx={{
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: field.required ? 'rgba(41, 174, 248, 0.1)' : '#f7f7f7',
              color: field.required ? '#000000' : '#4F4F4F',
              borderRadius: '12px 12px 0px 0px',
              fontSize: '12px',
              fontWeight: 600
            }}
          >
            <span>{field.label}</span>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default RequiredFields;